import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import SharedGPATabelConverter from "./SharedGPATabelConverter";
const TITLE = "جدول تحويل المعدل  الجامعي التراكمي GPA";
const DESCRIPTION =
  "جدول تحويل المعدل التراكمي (GPA) - حوّل بين الأنظمة العالمية (أمريكي، أوروبي، عربي) بسهولة! احسب معدلك المكافئ للجامعات الخارجية أو المنح الدراسية بدقة.";
const KEYWORDS =
  "تحويل المعدل من 4 الى 100 , تحويل المعدل من 5 الى 4 , تحويل المعدل من100 الى4 , تحويل المعدل من 4 الى 5 , تحويل المعدل من 4 الى 5 ";
const OG_URL = "https://do-calculate.com/calculator/ar/gpatableconverter";
function GPATabelConverter() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <div className="row">
        <div className="col">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <SharedGPATabelConverter />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <SecondAds />
        <br />
        <MainCalculatorsList></MainCalculatorsList>
        <br />
      </div>
      {" "}
      <br />
    </div>
  );
}
export default GPATabelConverter;
